import { useEffect, useRef, useState } from "react";
import { CheckCircle2, LoaderCircle } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function SpecialInvitationPage() {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api
      .post("/client-portal/special-invitation-links/redeem", { token })
      .then(() => {
        window.setTimeout(() => {
          navigate("/danisan-paneli?sekme=surecim", { replace: true });
        }, 500);
      })
      .catch((requestError) => setError(formatApiError(requestError)));
  }, [navigate, token]);

  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-pleiades-ivory p-4">
      <section className="w-full max-w-md border border-pleiades-border bg-white p-5 text-center sm:p-7">
        {error ? (
          <>
            <h1 className="text-lg font-semibold">Bağlantı kullanılamadı</h1>
            <p role="alert" className="mt-3 text-[13px] leading-6 text-red-700">{error}</p>
            <button
              type="button"
              onClick={() => navigate("/danisan-paneli", { replace: true })}
              className="mt-5 min-h-12 w-full bg-pleiades-blue px-4 text-[14px] font-semibold text-white"
            >
              Danışan paneline git
            </button>
          </>
        ) : (
          <>
            <div className="mx-auto flex h-12 w-12 items-center justify-center border border-pleiades-blue/30 bg-pleiades-blue/5 text-pleiades-blue">
              <LoaderCircle size={24} className="animate-spin" aria-hidden="true" />
            </div>
            <h1 className="mt-4 text-lg font-semibold">Özel davetiniz hazırlanıyor</h1>
            <p className="mt-2 text-[13px] leading-6 text-pleiades-slate">
              Paketiniz hesabınıza bağlanıyor. Ardından başlangıç anketiniz açılacak.
            </p>
            <div className="sr-only" aria-live="polite"><CheckCircle2 /> İşlem sürüyor</div>
          </>
        )}
      </section>
    </main>
  );
}
